<div class="p-4 bg-white m-3 shadow-sm" *ngIf="(isSuperTaskAvailable$ | async)">
  <div class="pt-2 pb-4">  <small class="ml-3 mb-3" (click)="backToBulkUpload()" class="icn" *ngIf="isFromBulkUpload === 'true'">
    << Back to Bulk Upload</small></div>
  <app-task-header></app-task-header>
  <div class="row">
    <p-tabView [activeIndex]="index" class="summaryTask-tab col-12" (onChange)="handleChange($event)">
      <p-tabPanel>
        <ng-template pTemplate="header">
          <div class="row border-right">
            <span class="header-icon border rounded-circle p-3" [ngClass]="summaryStatus">
              <img src="../../../../../assets/images/summary_icon.png" alt="">
            </span>
          </div>
          <label>Summary</label>
        </ng-template>
        <!-- <app-task-summary-tab (tabChangeValue)="handleChange($event)" [subTaskList]="subTaskList"
        [statusPercentageMap]="statusPercentageMap"></app-task-summary-tab> -->
      </p-tabPanel>
      <!-- IM-21087 removing disabled condition from PERM -->
      <p-tabPanel *ngFor="let item of subTaskList; let i = index;">
        <ng-template pTemplate="header">
          <div class="row">
            <hr *ngIf="i !== 0" style="width: 25%;position: absolute;top: 3rem;" />
            <span class="header-icon border rounded-circle p-3" [ngClass]="{'filed':item?.statusCode=='FILED' && !item.summaryBorderClassName,
          'inprogress': (item?.statusCode === 'INPROGRESS' && !item.summaryBorderClassName) || (item.summaryBorderClassName && item.summaryBorderClassName === 'inprogress'),
          'new':item?.statusCode === 'FILED' && disableRfe && !item.summaryBorderClassName,
          'responded':item?.statusCode === 'RESPONDED' && !item.summaryBorderClassName,
        'completed': (item.summaryBorderClassName && item.summaryBorderClassName === 'completed') ||
                      (item.statusCode && item.statusCode === 'APPROVED') }">
              <img alt="" src="{{item.imgPath}}">
            </span>
            <hr *ngIf="i !== (subTaskList.length - 1)" style="width: 25%;position: absolute;top: 3rem;right:0" />
          </div>
          <label><!--<span *ngIf="item.taskTypeCode === 'PERM' && !permAccessible" class="pi pi-info-circle"
              pTooltip="PERM is only accesible after Prevailing Wage Determination is issued and Recruitment Effort is completed"></span> -->
            <!-- <span *ngIf="item.visaTypeName && item.visaTypeName != 'Others' && item.immigrationFamilyBased != 'REMVCONDTRES' && item.immigrationFamilyBased != 'AMERASIANI360'
           && item.immigrationFamilyBased != 'WIDOWERUSI360' &&
           item.immigrationFamilyBased != 'VAWASPOUSEI360' &&
           item.immigrationFamilyBased != 'VAWACHILDI360' && item.immigrationFamilyBased != 'VAWAPARENTI360'">{{ item.visaTypeName}}</span> -->
            <span [hidden]="isSimplify"
              *ngIf="item.visaTypeName && item.visaTypeName != 'Others' && !(['REMVCONDTRES','AMERASIANI360','WIDOWERUSI360','VAWASPOUSEI360','VAWACHILDI360','VAWAPARENTI360'].includes(item.immigrationFamilyBased))">{{item.visaTypeName}}
            </span>
            {{ item.taskTypeName }}
          </label>
          <small *ngIf="item.isOutside" class="text-secondary d-block">({{ item.taskTypeName }} not filed in
            Imagility)</small>
        </ng-template>
      </p-tabPanel>
    </p-tabView>
    <div *ngIf="userType != 'Beneficiary' && superTaskDetails?.visaType?.code == 'H1-B'"
      style="position:absolute;right:1.5rem">
      <app-help-video-overlay #helpVideoComponent></app-help-video-overlay>
    </div>
  </div>
  <router-outlet></router-outlet>
  <!-- <app-petition-tab [isOutside]="isOutside"></app-petition-tab> -->
  <!-- <app-rfe-tab></app-rfe-tab> -->
</div>
<p-dialog header="Update Petition Details" [(visible)]="displayDialog" modal="true">
  <hr class="mt-0" />
  Before you begin to Build the RFE Response please <br />
  upload the Filled Petition Document and the documents related to your filing.
  <hr />
</p-dialog>
